import "pure-react-carousel/dist/react-carousel.es.css";

import { CarouselProvider } from "pure-react-carousel";

import React, { ReactNode, useState } from "react";

import CarouselContents from "./CarouselContents/CarouselContents";
import style from "./style.module.scss";

interface Props {
    children?: ReactNode | ReactNode[];
    interval: { automatic: boolean; speed: number };
    fullWidth?: boolean;
    roundedCorners?: boolean;
    pauseOnHover?: boolean;
    actionButtonClick?: (action: string, index: number) => void;
    carouselPreviousButtonAriaLabel?: string;
    carouselNextButtonAriaLabel?: string;
    carouselPlayButtonAriaLabel?: string;
    carouselPauseButtonAriaLabel?: string;
    carouselSliderAriaLabel?: string;
    carouselSlideAriaLabel?: string;
    carouselSlideDotAriaLabel?: string;
}

export const ImageCarousel = (props: Props): JSX.Element => {
    const {
        interval,
        children,
        fullWidth,
        roundedCorners = true,
        pauseOnHover = false,
        actionButtonClick,
        ...other
    } = props;
    const [playing, setPlaying] = useState(interval?.automatic);
    const intervalSpeed = interval?.speed ? interval?.speed * 1000 : 5000;

    return (
        <CarouselProvider
            isPlaying={playing}
            interval={intervalSpeed}
            naturalSlideWidth={100}
            naturalSlideHeight={100}
            isIntrinsicHeight={true}
            totalSlides={React.Children.count(children)}
            data-test-id="ImageCarousel"
            className={style.imageCarousel}
            infinite={true}
        >
            <CarouselContents
                fullWidth={fullWidth}
                roundedCorners={roundedCorners}
                pauseOnHover={pauseOnHover}
                interval={interval}
                setPlaying={setPlaying}
                actionButtonClick={actionButtonClick}
                {...other}
            >
                {children}
            </CarouselContents>
        </CarouselProvider>
    );
};

export default ImageCarousel;
